import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  SecurityContext,
  ViewEncapsulation,
  HostListener,
  ChangeDetectorRef,
} from "@angular/core";
import { ResizeService } from "src/app/services/resize.service";
import { ScrollService } from "src/app/services/scroll.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "src/app/i18n/translation.service";
import { NavigationEnd, Router } from "@angular/router";
import { PlatformService } from "src/app/services/platform.service";
import { Location } from "@angular/common";
import { catchError, forkJoin, of, Subject, Subscription } from "rxjs";
import { SharedService } from "src/app/services/shared.service";
import { MultimediaService } from "src/app/services/apis/multimedia.service";
import { RouteLocalizationPipe } from "src/app/pipes/route-localization.pipe";
import { GUID } from "src/app/const/guid";
import { Store } from "@ngrx/store";
import { DomSanitizer } from "@angular/platform-browser";
import { logMessage } from "src/app/helpers/logs";
import { UserService } from "src/app/services/apis/user.service";
import { RecaptchComponent } from "../recaptch/recaptch.component";
import { NgForm } from "@angular/forms";

const defaultTopUpSetting = {
  min: 700,
  max: 50000,
};

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('form') loginForm!: NgForm;
  verifyCaptchaToken: string = '';  
  @ViewChild('recaptchEle') recaptchEle!: RecaptchComponent;  
  isDefaultLayoutEnabled: boolean = false;
  userData: any = null;
  getProfileByTokenResponse: any = null;
  validateOTPPhoneResponse: any = null;
  validateOTPEmailResponse: any = null;
  getTokenByB2CResponse: any = null;
  registerUserPhoneResponse: any = null;
  registerUserEmailResponse: any = null;
  settings: any = null;
  topUpSetting: any = {
    min: defaultTopUpSetting.min,
    max: defaultTopUpSetting.max,
  };
  isDataReady: boolean = false;
  promotionList: any = [];
  banners: any = [];
  userWalletAmount: any = ""; // Declare a variable to store the fetched data
  inputValue: number | string = ""; // Variable to store the input value
  userWalletAmmount: any = "";
  isIconClicked = false;
  isIconClicked2 = false;
  timeoutId: any; // To store the timeout reference
  private routerEventsSubscription: Subscription;
  isChangeLangBtnDisabled: boolean = false;
  isLoadingEnabled: boolean = false;
  isSentOtp: boolean = false;
  loginCarousel: any = [
    "assets/images/header-carousel-img.png",
    "assets/images/header-carousel-img.png",
    "assets/images/header-carousel-img.png",
  ];

  isOTPCounterEnd: boolean = false;
  @ViewChild("otpCounter") otpCounter!: any;
  isLoginByPhoneNumberEnabled: boolean = true;
  isLoginModalEnabled: boolean = false;
  mobileNumber: string = "";
  maskedMobileNumber: string = '';

  // +97430048341 
  email: string = "";
  otp: number | null = null;
  sendOTPFormSubmitted: boolean = false;
  errorMsg: any = "";
  isSendOTPEnabled: boolean = false;
  otpErrorMsg: string = "";
  lang: string = "en";
  private readonly _destroying$ = new Subject<void>();
  isSearchModal: boolean = false;
  isModalEnabled: boolean = false; //top up modal
  @Input() pageType: string = "";
  userMenu: any = [
    {
      title: "DASHBOARD.VIEW_PROFILE",
      svg: "assets/svgs/user-new.svg",
      link: "/dashboard/my-profile",
      fill: "#000000",
    },
    // {
    //   title: "DASHBOARD.MY_WALLET",
    //   svg: "assets/svgs/wallet.svg",
    //   link: "/dashboard/my-wallet",
    //   fill: "",
    // },
    // {
    //   title: 'Check My Appointments',
    //   svg: 'assets/svgs/whistle-blowing.svg',
    //   link: '/dashboard/apppointment-history',
    // },
    {
      title: 'admin.my-vehicles',
      svg: 'assets/svgs/car-black.svg',
      link: '/dashboard/my-vehicle',
    },
    // {
    //   title: 'Statistics',
    //   svg: 'assets/svgs/whistle-blowing.svg',
    //   link: '/dashboard/home',
    // },
    // {
    //   title: 'Help',
    //   svg: 'assets/svgs/whistle-blowing.svg',
    //   link: '/dashboard/help',
    // }
  ];
  isUserMenuEnabled: boolean = false;
  isEn: boolean = this.translationService.getSelectedLanguage() === "en";
  isStickySettingEnabled: boolean = true;
  isMobileMenuEnabled: boolean = false;
  @ViewChild("header", { static: true }) headerElement!: ElementRef;
  isStickyEnabled: boolean = false;
  logo: any = {
    woqod: {
      // normal: "assets/images/logo-1-white.svg",
      normal: "assets/svgs/Header-Newlogo.svg",
      // normal: "assets/images/logos/header.svg",
      // sticky: "assets/images/logos/header.svg"
      sticky: "assets/svgs/Header-Newlogo.svg",
    },
    fahes: {
      normal: "assets/images/fahes-white-text.svg",
      sticky: "assets/images/logos/faheslogonew_.png",
      // sticky: "assets/images/logos/fahes-white.svg",
    },
  };
  topLinks: any = [];

  menuItems: any = {
    fahes: {
      en: [],
      ar: [],
    },
  };

  langs: any = this.translate.getLangs() || [];
  currentLang: string = this.translationService.getSelectedLanguage();
  isLangMenuOpened: boolean = false;

  isAuth: any;
  isSubmitted: boolean = false;
  checkBox1: any = {
    title: {
      en: 'To proceed recharge you agree<br/> the <a href="en/pages/termsconditions">Terms and Conditions</a>',
      ar: 'لمتابعة الدفع، فإنك توافق على<br/> <a href="ar/pages/termsconditions">الشروط والأحكام</a>',
    },
    name: "limitedHours",
    value: false,
  };

  isFirstRoute: boolean = true;
  isAlreadyInitiated: boolean = false;
    
  constructor(
    private multimediaService: MultimediaService,
    private translate: TranslateService,
    private translationService: TranslationService,
    private resizeService: ResizeService,
    private router: Router,
    public platformService: PlatformService,
    private location: Location,
    private sharedService: SharedService,
    private routeLocalizationPipe: RouteLocalizationPipe,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
    private TranslationService: TranslationService,
    private userService: UserService,
    private cdk: ChangeDetectorRef
  ) {

    setTimeout(() => {
      this.resizeService.screenWidthChange$.subscribe(data => this.resize());
    });    
    // this.getData();
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // this.getData();

        if (!this.isAlreadyInitiated) this.isAlreadyInitiated = true;
        this.getData();

        if (!this.isFirstRoute) {
          setTimeout(() => {
            this.handleSticky("eachRouteChange");
          });
        }
        this.isFirstRoute = false;
        //
        const url = event?.urlAfterRedirects;
        const isRTL = !url.startsWith("/en");
        this.isEn = !isRTL;
        const onlyEnPages: any = ["careers/view-all-jobs", "careers/career"];
        if (onlyEnPages.some((route: string) => url.indexOf(route) !== -1)) {
          this.isChangeLangBtnDisabled = true;
          if (isRTL) {
            this.sharedService.enableFullLoader();
            setTimeout(() => {
              this.translationService.setLanguage("en");
              setTimeout(() => {
                if (typeof window !== "undefined") window.location.reload();
              });
            }, 100);
          }
        } else {
          this.isChangeLangBtnDisabled = false;
        }
      }
    });
  }

    handleDashboardLayout(){
    if (typeof window !== 'undefined'){
      const url = window.location.href;
      const isDahboardPages = url.indexOf("dashboard/") !== -1;
      if(isDahboardPages){
        const isCurrentPageFromTheBelowPages = url.indexOf("dashboard/profile") !== -1 || url.endsWith("/dashboard/wallet");
        return isCurrentPageFromTheBelowPages;
      }else{
        this.isDefaultLayoutEnabled = true;
        return true;
      }
    }
    return false;
  }

  isEnAlreadyFetched: boolean = false;
  isArAlreadyFetched: boolean = false;

  getData() {
    this.lang = this.TranslationService.getSelectedLanguage();
    if(!this.handleDashboardLayout()) return;    

    if(this.lang === 'en' && this.isEnAlreadyFetched) return;
    if(this.lang === 'ar' && this.isArAlreadyFetched) return;

    if(this.lang === 'en' && !this.isEnAlreadyFetched) this.isEnAlreadyFetched = true;
    if(this.lang === 'ar' && !this.isArAlreadyFetched) this.isArAlreadyFetched = true;
    
    const pageType = 'fahes';
    this.isDataReady = false;
    forkJoin({
      getHeader: this.multimediaService.getHeader({}, this.lang, pageType).pipe(catchError((err) => of(null))),
      getHeaderHelper: this.multimediaService.getHeaderHelper({}, pageType).pipe(catchError((err) => of(null))),
      getPromotionList: this.multimediaService.getPromotionsList({ pageSize: 5000, pageNumber: 1 }).pipe(catchError((err) => of(null))),
      // getAmountOfWallet: this.userService.isUserLoggedIn() ? this.multimediaService.getAmountOfWallet({}).pipe(catchError((err) => of(null))): of(null),
      getFahesSettings: this.multimediaService.getFahesSettings({}).pipe(catchError((err) => of(null))),
      getLoginBnanners: this.multimediaService.getLoginBnanners({}).pipe(catchError((err) => of(null))),
    }).subscribe({
      next: (results) => {
        logMessage("Header Response ", results);
        if (results.getHeader) this.getHeader(results.getHeader);
        if (results.getPromotionList)
          this.getPromotionList(results.getPromotionList);
        if (results.getHeaderHelper)
          this.getHeaderHelper(results.getHeaderHelper);
        // if (results.getAmountOfWallet)
        //   this.getAmountOfWallet(results.getAmountOfWallet);
        if (results.getFahesSettings)
          this.getFahesSettings(results.getFahesSettings);
        if (results.getLoginBnanners)
          this.getLoginBnanners(results.getLoginBnanners);

        // console.log('here 1');
        
        this.isDataReady = true;
// this.cdk.markForCheck();
// this.cdk.detectChanges();

        // console.log('here 12');        
        this.checkIfHeaderIsReady();

        // setTimeout(() => {
        //           this.checkIfHeaderIsReady();
        // }, 3000);
      },
      error: (err) => {
        logMessage("HEADER Unexpected error in forkJoin:", err);
      },
    });
  }

  ngOnInit() {
    this.userData = this.userService.getUserData();
    if (!this.isAlreadyInitiated) this.getData();
  }

  getLoginBnanners(response: any) {
    let banners = [];

    // Ensure response is an array
    if (Array.isArray(response)) {
      banners = response;
    } else {
      // Convert single object to array
      banners = [response];
    }

    // Sort banners by orderNo
    const sortedBanners = banners.sort((a, b) => a.orderNo - b.orderNo);

    // Convert sorted banners into language-based arrays
    this.loginCarousel = {
      backgroundIMG: {
        en: sortedBanners.map((banner) => banner.bgImageEN),
        ar: sortedBanners.map((banner) => banner.bgImageAR),
      },
    };
  }

  getFahesSettings(response: any) {
    this.settings = response;
    this.topUpSetting = {
      min: response?.minTopupAmount || defaultTopUpSetting.min,
      max: response?.maxTopupAmount || defaultTopUpSetting.max,
    };
  }

  getPromotionList(response: any) {
    this.promotionList =
      (response?.pageItems || [])
        .filter((item: any, index: number) =>
          this.isDateLessThanOrEqualToday(item?.endDate)
        )
        .map((item: any) => item.offersAndPromotionsID) || [];
  }

  isDateLessThanOrEqualToday(date: any) {
    const endDate = new Date(date).setHours(0, 0, 0, 0);
    const tDate = new Date().setHours(0, 0, 0, 0);
    return endDate > tDate;
  }

  // getAmountOfWallet(response: any) {
  //   // Assuming response is an array of numbers, parse each element to an integer
  //   this.userWalletAmount = response
  //     .filter((item: any) => item)
  //     .map((amount: any) => parseInt(amount.toString(), 10));
  // }

  // Function to update the inputValue when a button is clicked
  updateInput(amount: number) {
    this.inputValue = amount;
  }

  ensureArray(value:any) {
    return Array.isArray(value) ? value : [value];
  }


  getHeaderHelper(response: any): void {
  let temp: any[] = [];

  if (Array.isArray(response) && response.length > 0) {
    temp = response.map((item: any) => ({
      link: null,
      title: {
        en: item.titleEN || "",
        ar: item.titleAR || "",
      },
      icon: item.iconID || "",
      href: item.url || "",
    }));
  } else if (response && typeof response === "object") {
    temp.push({
      link: null,
      title: {
        en: response.titleEN || "",
        ar: response.titleAR || "",
      },
      icon: response.iconID || "",
      href: response.url || "",
    });
  }

  this.topLinks = temp;
}

  getHeader(response: any): void {
    const headerStr = response?.treeItems || "";
    if (!headerStr) return;
    const headerResponseFull = headerStr ? JSON.parse(headerStr) : null;
    if (!headerResponseFull) return;
    const headerResponse =
      headerResponseFull && headerResponseFull.length > 0
        ? headerResponseFull[0]
        : null;
    if (!headerResponse) return;
    const header =
      headerResponse.children && headerResponse.children.length > 0
        ? headerResponse.children
        : null;
    if (!header) return;
    // console.log(header);

    let temp = [];

    for (let index = 0; index < header.length; index++) {
      if (header[index].data.IsSectionVisible === "True") {
        const hasChildrens =
          header[index].children && header[index].children.length > 0;
        temp.push({
          title: header[index].text,
          link: header[index].data.URL || "",
          linkTarget: header[index].data.URLTarget || "",
          // link: hasChildrens ? '' : header[index].data.URL,
          isNew: true,
          subMenu: hasChildrens
            ? this.handleMenuInner(header[index].children)
            : [],
        });
      }
    }

    this.menuItems[this.pageType][this.lang] = temp;
  }

  checkIfHeaderIsReady() {
    // console.log(this.isDataReady);
    
    setTimeout(() => {
      this.handleSticky("headerDataReady");
    });
  }

  handleMenuInner(children: any) {
    let temp = [];
    for (let index = 0; index < children.length; index++) {
      if (children[index].data.IsSectionVisible === "True") {
        if (
          (children[index].children && children[index].children.length > 0) ||
          !children[index]?.data?.Image ||
          children[index]?.data?.Image === GUID.empty
        ) {
          temp.push({
            menuWithTitle: [
              {
                title: children[index].text || "",
                link: children[index].data.URL || "",
                linkTarget: children[index].data.URLTarget || "",
                list:
                  (children[index].children || [])
                    .filter(
                      (item: any) => item.data.IsSectionVisible === "True"
                    )
                    .map((item: any) => {
                      return {
                        title: item.text || "",
                        link: item.data.URL || "",
                        linkTarget: item.data.URLTarget || "",
                      };
                    }) || [],
              },
            ],
          });
        } else {
          temp.push({
            menuDescription: {
              img: children[index].data.Image || "",
              title: children[index].text || "",
              desc: children[index].data.Description || "",
              btn: {
                // text: 'Read more <span class="mt-[3px]">&#8594;</span>',
                text: children[index].data.ButtonText || "",
                link: children[index].data.URL || "",
                linkTarget: children[index].data.URLTarget || "",
              },
            },
          });
        }
      }
    }
    return temp;
  }

  ngAfterViewInit(): void {
    this.resizeService.screenWidth$.subscribe((screenWidth) =>
      this.closeMobileMenu()
    );

    let resizeTimer: any;
    if (typeof window !== "undefined") {
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);

        this.handleSticky("resize");
        resizeTimer = setTimeout(() => {
          this.handleSticky("resize");
          // Perform actions after resizing stops
        }, 300); // Adjust delay as needed
      });
    }
  }

  setLang() {
    this.translationService.setLanguage(this.isEn ? "ar" : "en");
    setTimeout(() => {
      this.isEn = this.translationService.getSelectedLanguage() === "en";
    });
  }

  toggleMobileMenu() {
    if (typeof window !== "undefined") {
      this.isMobileMenuEnabled = !this.isMobileMenuEnabled;
      document.body.style.overflow = this.isMobileMenuEnabled
        ? `hidden`
        : `auto`;
    }
  }
  isMobile: boolean = false;
  closeMobileMenu(event: any = null) {
    if (this.isMobileMenuEnabled) this.toggleMobileMenu();
    this.isLangMenuOpened = false;
  }

  bookNow(){
    this.closeMobileMenu();
        setTimeout(() => {
              this.router.navigate([this.routeLocalizationPipe.transform("my-vehicle")]);
        });
  }

  resize() {
    this.isMobile = this.resizeService.isMobile();
  }

  toggleLangMenu() {
    this.isLangMenuOpened = !this.isLangMenuOpened;
  }

  closeSearchModal(event: any) {
    this.isSearchModal = false;
    document.body.style.overflow = `auto`;
  }

  login() {
    this.mobileNumber = '';
    this.isLoginModalEnabled = true;
  }

  logout() {
    this.multimediaService.logout().subscribe((response) => {
      if(response?.isSuccess){
        this.userService.clearUserData();
        this.userData = null;
        this.getProfileByTokenResponse = null;
        this.validateOTPPhoneResponse = null;
        this.getTokenByB2CResponse = null;
        this.registerUserPhoneResponse = null;
        this.registerUserEmailResponse = null;
        this.isUserMenuEnabled = false;
        this.isLoginByPhoneNumberEnabled = true;
        this.mobileNumber = "";//30048341
        this.email = "";
        this.otp = null;
        this.sendOTPFormSubmitted = false;
        this.errorMsg = "";
        this.isSendOTPEnabled = false;
        this.isLoadingEnabled = false;
        this.isSentOtp = false;
        document.body.style.overflow = "";

        setTimeout(() => {
              this.router.navigate([this.routeLocalizationPipe.transform("")]);
        });
        // empty login pop up
      }else{
        // error logout
      }
    }, (error:any) => {
      // error logout
    });    
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  toggleIcon() {
    this.isIconClicked = !this.isIconClicked;

    // Clear any existing timeout if the icon is clicked again before the timeout ends
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Set a timeout to revert `isIconClicked` to false after 5 minutes (300,000 milliseconds)
    if (this.isIconClicked) {
      this.timeoutId = setTimeout(() => {
        this.isIconClicked = false;
        // Update the UI by triggering Angular's change detection
      }, 10000); // 5 minutes = 300,000 milliseconds
    }
  }

  toggleIcon2() {
    this.isIconClicked2 = !this.isIconClicked2;
  }

  toPayment() {
    this.isSubmitted = true;

    const valueAsNumber = +this.inputValue; // Convert inputValue to a number
    const isValueTooLow = valueAsNumber < this.topUpSetting.min;
    const isValueTooHigh = valueAsNumber > this.topUpSetting.max;
    const isValueInvalid = !this.inputValue || isValueTooLow || isValueTooHigh;

    if (isValueInvalid) {
      return; // Stop the process if any condition fails
    }

    if (this.checkBox1.value && this.inputValue) {
      this.isModalEnabled = false;
      const sanitized = this.sanitizer.sanitize(
        SecurityContext.URL,
        this.inputValue
      );
      // 
      
      // 
      sessionStorage.setItem('topupA',this.sharedService.encryptAmount(`${sanitized}`));
      // 
      setTimeout(() => {
        const url = this.routeLocalizationPipe.transform(`/checkout`);
        // if(url === '/en/checkout' || url === '/ar/checkout') this.router.navigateByUrl(url);        
        this.sharedService.redirect(url);
      });
    }
  }

  clickOnMenuItem() {
    this.isUserMenuEnabled = false;
  }

  backLogin() {
    this.isSendOTPEnabled = false;
  }

  onOTPCounterEnd() {
    this.isOTPCounterEnd = true;
  }

  resendPin() {
    this.errorMsgOTP = null;
    // this.isLoadingEnabled = true;
    if (!this.isOTPCounterEnd) return; // prevent clicking before countdown ends

    this.resetFieldOTP();
    // this.sendOTP();

    // Set to false to show the timer component again
    this.isOTPCounterEnd = false;

    this.isLoadingEnabled = true;    
    this.isSendOTPEnabled = false;
    this.isSentOtp = false;
    this.mobileNumber = this.tempPhone;
    setTimeout(() => {
      this.onSubmitLogin(this.loginForm);
    });
    // Allow view to update and re-create the component before restarting the timer
    // setTimeout(() => {
    //   if (this.otpCounter && this.otpCounter.restart) {
    //     this.otpCounter.restart();
        
    //   }
    // }, 0);
    // this.isLoadingEnabled = false;
  }

  // sendOTP() {
  //   // this.onSubmitLogin(this.loginForm);
  // }

  resetFieldOTP() {
    this.otp = null;
    this.otpErrorMsg = "";
  }

  verifyOTP(form: any) {
    if(!form?.controls?.otp?.valid){

    }else{
      this.errorMsgOTP = null;
      this.recaptchEle.executeRecaptcha();
    }
  }

  verifyOTP2(form: any) {
    this.errorMsgOTP = null;    
    this.isLoadingEnabled = true;
    this.otpErrorMsg = "";
    if (form?.controls?.otp?.valid) {
      if (this.otpCounter) this.otpCounter.stopTimer();
      if (this.isLoginByPhoneNumberEnabled) {
        //phone

        this.multimediaService
          .validateOTPPhone({
            RefID: this.registerUserPhoneResponse?.result?.id || '',
            OTP: this.otp,
          }, this.verifyCaptchaToken)
          .subscribe(
            (validateOTPPhoneResponse) => {
              // console.log(validateOTPPhoneResponse);
              this.validateOTPPhoneResponse = validateOTPPhoneResponse;
              if (this.validateOTPPhoneResponse?.result?.userInfo) {
                // this.multimediaService
                //   .getTokenByB2C(
                //     {},
                //     {
                //       B2CToken: this.validateOTPPhoneResponse.userInfo,
                //       DevicePrint: this.userService.getUserDevicePrint(),
                //     }
                //   )
                //   .subscribe(
                //     (getTokenByB2CResponse) => {
                      // console.log(getTokenByB2CResponse);
                      // this.getTokenByB2CResponse = getTokenByB2CResponse;
                      // if (this.getTokenByB2CResponse?.token) {
                        const userData = {
                          userID: this.validateOTPPhoneResponse?.result?.id,
                          // phoneNumber: this.registerUserPhoneResponse.userName,
                          // firstToken: this.validateOTPPhoneResponse.userInfo,
                          bearerToken: this.validateOTPPhoneResponse?.result?.userInfo,
                        };

                        this.userService.updateUserData(userData);

                        setTimeout(() => {
                          this.multimediaService.getProfileByToken().subscribe(
                            (getProfileByTokenResponse) => {
                              this.getProfileByTokenResponse =
                                getProfileByTokenResponse;

                              this.userService.updateUserData(
                                {...this.getProfileByTokenResponse,...{
                                  "isRegistered": this.validateOTPPhoneResponse?.result?.isRegistered,
                                  "isEmailRequired":this.validateOTPPhoneResponse?.result?.isEmailRequired,
                                  "isQIDMandatory":this.validateOTPPhoneResponse?.result?.isQIDMandatory,
                                  "isRegistrationMandatory":this.validateOTPPhoneResponse?.result?.isRegistrationMandatory,
                                  "isEmailVerificationRequired":this.validateOTPPhoneResponse?.result?.isEmailVerificationRequired
                                }}
                              );
                              // console.log(getProfileByTokenResponse);
                              setTimeout(() => {
                                document.body.style.overflow = "";
                                this.userData = this.userService.getUserData();
                                  this.closeLoginModal();
                                // this.multimediaService
                                //   .getCurrentBalance()
                                //   .subscribe((results: any) => {
                                //     this.getCurrentBalance(results);
                                //     this.multimediaService
                                //       .getAmountOfWallet()
                                //       .subscribe((results: any) => {
                                //         this.getAmountOfWallet(results);
                                //         this.closeLoginModal();
                                //       });
                                //   });

                                // console.log(this.userData);
                                // When email login you have to check on attribute is email requeired to move it to profile
                                // do next step
                                const forceUpdate = !this.validateOTPPhoneResponse?.result?.isRegistered && this.validateOTPPhoneResponse?.result?.isRegistrationMandatory;
                                // const isUserRegistered = this.validateOTPPhoneResponse?.result?.isRegistered;
                                this.closeLoginModal();                           


        const url = this.routeLocalizationPipe.transform((`/dashboard/my-profile${forceUpdate ? '-required' : ''}`));
        if(
          url === '/en/' || 
          url === '/ar/' ||

          url === '/en/dashboard/my-profile' || 
          url === '/ar/dashboard/my-profile' ||

          url === '/en/dashboard/my-profile-required' || 
          url === '/ar/dashboard/my-profile-required'

        ) this.sharedService.redirect(url);   

                              });
                            },
                            (error) => {
                              // error
              this.errorMsgOTP = {
                en:'OTP entered is incorrect',
                ar:'الرمز المؤقت المُدخل غير صحيح',
              }
                              this.isLoadingEnabled = false;
                            }
                          );
                        });
              } else {
                // error
              this.errorMsgOTP = {
                en: this.validateOTPPhoneResponse?.messageEN,
                ar: this.validateOTPPhoneResponse?.messageAR,
              }
                this.isLoadingEnabled = false;
              }
            },
            (error) => {
              // error case
              this.errorMsgOTP = {
                en:'OTP entered is incorrect',
                ar:'الرمز المؤقت المُدخل غير صحيح',
              }
              this.isLoadingEnabled = false;
            }
          );

        // this.resetFieldOTP();
        // this.isLaterVerificationEmail = true;
        // if (this.otpCounter) {
        //   this.otpCounter.resetTimer();
        //   this.otpCounter.startTimer();
        // }
      } 
      // else {
      //   //email
      
      //   this.multimediaService
      //   .validateOTPPhone({
      //     userRefId: this.registerUserEmailResponse.id,
      //     otp: this.otp,
      //     Lang: this.lang,
      //     devicePrint: this.userService.getUserDevicePrint(),
      //   })
      //   .subscribe(
      //     (validateOTPEmailResponse) => {
      //       // console.log(validateOTPEmailResponse);
      //       this.validateOTPEmailResponse = validateOTPEmailResponse;
      //       if (this.validateOTPEmailResponse?.userInfo) {
      //         this.multimediaService
      //           .getTokenByB2C(
      //             {},
      //             {
      //               B2CToken: this.validateOTPEmailResponse.userInfo,
      //               DevicePrint: this.userService.getUserDevicePrint(),
      //             }
      //           )
      //           .subscribe(
      //             (getTokenByB2CResponse) => {
      //               // console.log(getTokenByB2CResponse);
      //               this.getTokenByB2CResponse = getTokenByB2CResponse;
      //               if (this.getTokenByB2CResponse?.token) {
      //                 const userData = {
      //                   userID: this.registerUserEmailResponse.id,
      //                   // phoneNumber: this.registerUserEmailResponse.userName,
      //                   firstToken: this.validateOTPEmailResponse.userInfo,
      //                   bearerToken: this.getTokenByB2CResponse.token,
      //                 };

      //                 this.userService.updateUserData(userData);

      //                 setTimeout(() => {
      //                   this.multimediaService.getProfileByToken().subscribe(
      //                     (getProfileByTokenResponse) => {
      //                       this.getProfileByTokenResponse =
      //                         getProfileByTokenResponse;

      //                       this.userService.updateUserData(
      //                         this.getProfileByTokenResponse
      //                       );
      //                       // console.log(getProfileByTokenResponse);
      //                       setTimeout(() => {
      //                         this.userData = this.userService.getUserData();

      //                         this.multimediaService
      //                           .getCurrentBalance()
      //                           .subscribe((results: any) => {
      //                             this.getCurrentBalance(results);
      //                             this.multimediaService
      //                               .getAmountOfWallet()
      //                               .subscribe((results: any) => {
      //                                 this.getAmountOfWallet(results);
      //                                 this.isLoginModalEnabled = false;
      //                               });
      //                           });

      //                         // console.log(this.userData);
      //                         // When email login you have to check on attribute is email requeired to move it to profile
      //                         // do next step
      //                       });
      //                     },
      //                     (error) => {
      //                       // error
      //                       this.errorMsg = {
      //                         en:'It seems like this mobile number is not associated with any registered account. You can register a new account by logging in with your mobile number.',
      //                         ar:'يبدو أن هذا الهاتف المحمول غير مرتبط بأي حساب مسجل. يمكنك تسجيل حساب جديد عن طريق تسجيل الدخول برقم هاتفك المحمول.',
      //                       }
      //                       this.isLoadingEnabled = false;
      //                     }
      //                   );
      //                 });
      //                 if(this.validateOTPEmailResponse?.isEmailVerificationRequired == true) {
      //                   this.router.navigateByUrl(
      //                     this.routeLocalizationPipe.transform(`/dashboard/profile`)
      //                   );
      //                 }
      //               } else {
      //                 // error
      //                 this.errorMsg = {
      //                   en:'It seems like this mobile number is not associated with any registered account. You can register a new account by logging in with your mobile number.',
      //                   ar:'يبدو أن هذا الهاتف المحمول غير مرتبط بأي حساب مسجل. يمكنك تسجيل حساب جديد عن طريق تسجيل الدخول برقم هاتفك المحمول.',
      //                 }
      //                 this.isLoadingEnabled = false;
      //               }
      //             },
      //             (error) => {
      //               // error case
      //               this.errorMsg = {
      //                 en:'It seems like this mobile number is not associated with any registered account. You can register a new account by logging in with your mobile number.',
      //                 ar:'يبدو أن هذا الهاتف المحمول غير مرتبط بأي حساب مسجل. يمكنك تسجيل حساب جديد عن طريق تسجيل الدخول برقم هاتفك المحمول.',
      //               }
      //               this.isLoadingEnabled = false;
      //             }
      //           );
                
      //       } else {
      //         // error
      //         this.errorMsg = {
      //           en:'It seems like this mobile number is not associated with any registered account. You can register a new account by logging in with your mobile number.',
      //           ar:'يبدو أن هذا الهاتف المحمول غير مرتبط بأي حساب مسجل. يمكنك تسجيل حساب جديد عن طريق تسجيل الدخول برقم هاتفك المحمول.',
      //         }
      //         this.isLoadingEnabled = false;
      //       }
      //     },
      //     (error) => {
      //       // error case
      //       this.errorMsg = {
      //         en:'It seems like this mobile number is not associated with any registered account. You can register a new account by logging in with your mobile number.',
      //         ar:'يبدو أن هذا الهاتف المحمول غير مرتبط بأي حساب مسجل. يمكنك تسجيل حساب جديد عن طريق تسجيل الدخول برقم هاتفك المحمول.',
      //       }
      //       this.isLoadingEnabled = false;
      //     }
      //   );

      // }
    } else {
      console.log("error otp not valid format");
      // will not reach here..
    }
  }

  otherAmount(){
    this.inputValue = '';
    const ele:any = document.querySelector("#inputValue");
    if(ele) ele.focus();
  }  

  closeLoginModal(){
    this.isLoginModalEnabled = false;
    document.body.style.overflow = '';
  }

  btnDisabled: boolean = false;
  onSubmitLogin(form: any) {
    if(this.isLoginByPhoneNumberEnabled ? !form?.controls?.mobileNumber?.valid : !form?.controls?.email?.valid){
      // 
    }else{
      this.errorMsg = null;
      this.btnDisabled = true;
      setTimeout(() => {
        this.btnDisabled = false;
      }, 2000);
      this.recaptchEle.executeRecaptcha();
    }
  }

  onRecaptchSuccess(recaptchToken: any) {
    this.verifyCaptchaToken = recaptchToken;
    
    if (this.verifyCaptchaToken) {
      if(!this.isSendOTPEnabled) this.onSubmitLogin2(this.loginForm);
      if(this.isSendOTPEnabled) this.verifyOTP2(this.loginForm);
    }
  }  

  errorMsgOTP: any;

  onSubmitLogin2(form: any) {
    this.sendOTPFormSubmitted = true;
    this.isLoadingEnabled = true;
    
    
    if (
      (this.isLoginByPhoneNumberEnabled &&
        form?.controls?.mobileNumber?.valid) ||
      (!this.isLoginByPhoneNumberEnabled && form?.controls?.email?.valid)
    ) {
      if (this.isLoginByPhoneNumberEnabled) {
        //phone
        this.isSentOtp = true;
        this.multimediaService
          .registerUserPhone({
            phone: this.mobileNumber.replace("+974", ""),
            lang: this.lang,
            // DevicePrint: this.userService.getUserDevicePrint(),
          }, this.verifyCaptchaToken)
          .subscribe(
            (registerUserPhoneResponse) => {
              this.registerUserPhoneResponse = registerUserPhoneResponse;
              // console.log(registerUserPhoneResponse);

              if (this.registerUserPhoneResponse?.isSuccess) {
                this.otp = null;
                this.errorMsgOTP = null;
                this.isSendOTPEnabled = true;
                this.mobileNumber = this.maskMobileNumber(this.mobileNumber);

                setTimeout(() => {
                  if (this.otpCounter) this.otpCounter.startTimer();
                  this.isLoadingEnabled = false;
                  
                });
                
              } else {
                this.errorMsg = {
                  en:registerUserPhoneResponse?.messageEN,
                  ar:registerUserPhoneResponse?.messageAR,
                }
                  
                  this.isLoadingEnabled = false;
                }
            },
            (error) => {
              this.errorMsg = {
                en:'The service is temporarily unavailable.',
                ar: 'الخدمة غير متاحة مؤقتًا.',
              }
                this.isLoadingEnabled = false;
              }
          );
      }
      //  else {
      //   //email
      //   this.isSentOtp = true;
      //   this.multimediaService
      //   .registerUserEmail({
      //     UserName: this.email,
      //     Lang: this.lang,
      //     DevicePrint: this.userService.getUserDevicePrint(),
      //   })
      //   .subscribe(
      //     (registerUserEmailResponse) => {
      //       this.registerUserEmailResponse = registerUserEmailResponse;
      //       // console.log(registerUserEmailResponse);

      //       if (
      //         this.registerUserEmailResponse?.id &&
      //         this.registerUserEmailResponse?.result &&
      //         this.registerUserEmailResponse?.isRegistered == true 
      //       ) {
      //         this.isSendOTPEnabled = true;
      //         setTimeout(() => {
      //           if (this.otpCounter) this.otpCounter.startTimer();
      //           this.isLoadingEnabled = false;
      //         });
      //       } else {
      //         this.errorMsg = {
      //           en:'It seems like this mobile number is not associated with any registered account. You can register a new account by logging in with your mobile number.',
      //           ar:'يبدو أن هذا الهاتف المحمول غير مرتبط بأي حساب مسجل. يمكنك تسجيل حساب جديد عن طريق تسجيل الدخول برقم هاتفك المحمول.',
      //         }
      //         this.email = "";
      //         this.isSendOTPEnabled = false;
      //           this.isLoadingEnabled = false;
      //         }
      //     },
      //     (error) => {
      //       this.errorMsg = {
      //         en:'It seems like this mobile number is not associated with any registered account. You can register a new account by logging in with your mobile number.',
      //         ar:'يبدو أن هذا الهاتف المحمول غير مرتبط بأي حساب مسجل. يمكنك تسجيل حساب جديد عن طريق تسجيل الدخول برقم هاتفك المحمول.',
      //       }
      //         this.isLoadingEnabled = false;
      //       }
      //   );






      // }
    }
  }

  formatAmount(amount: any): string {
  if (!amount) return "";
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

get maskedAmount(): string {
  const real = this.userWalletAmmount?.result?.toString() || "";
  return "*".repeat(real.length);
}

get formattedAmount(): string {
  return this.formatAmount(this.userWalletAmmount?.result) || '0';
}

  tempPhone: string = '';
  maskMobileNumber(number: string): string {
    if(number.indexOf("*") !== -1) {
    } else{
      this.tempPhone = number;
    }
  if (!number || number.length <= 4) return number;

  const visible = number.slice(-4);                 // last 4 digits
  const masked = '*'.repeat(number.length - 4);     // mask the rest

  return masked + visible;
}

  againsteps() {
    this.isOTPCounterEnd = false;
    this.isSendOTPEnabled = false;
    this.isSentOtp = false; // ✅ This will remove the class
    this.mobileNumber = ''; // optional: clear the input if needed
    this.sendOTPFormSubmitted = false; // optional: reset validation
    this.errorMsg = "";
  }
  switchLoginType() {
    this.isLoginByPhoneNumberEnabled = !this.isLoginByPhoneNumberEnabled;
    this.isSendOTPEnabled = false;
    this.mobileNumber = "";
    this.email = "";
    this.sendOTPFormSubmitted = false;
    this.errorMsg = "";
  }

  handleSticky(fromWhereTriggered: string) {
    if (typeof window === "undefined") return;
    const whichPageYouAreIn = this.whichPageYouAreIn();
    if (!this.headerElement) return;
    const headerHight = this.headerElement.nativeElement.offsetHeight;
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    // reset

    document.body.style.paddingTop = `0px`;
    //
    // implementation
    if (whichPageYouAreIn === "homepage") {
      if (scrollPosition > headerHight) {
        this.isStickyEnabled = true;
      } else {
        this.isStickyEnabled = false;
      }
    } else {
      document.body.style.paddingTop = `${headerHight - 2}px`;
      this.isStickyEnabled = true;
    }
    // console.log('handle sticky: ', fromWhereTriggered, whichPageYouAreIn, headerHight, scrollPosition);
    // result by end:
    // document.body.style.paddingTop = `${headerHeight - 1}px`;
    // document.body.style.paddingTop = `0px`;
    // this.isStickyEnabled = true;
  }

  whichPageYouAreIn() {
    const fullPath = this.location.path();
    const excludePages = [
      "", //refere to main home page
      "/fahes",
      "/qjet",      
      "/homepage-testing-ssr",
    ];
    const path = fullPath.replace(
      `/${this.translationService.getSelectedLanguage()}`,
      ``
    );
    const isHomePage = excludePages.filter((item) => item === path).length > 0;
    return isHomePage ? "homepage" : "innerpage";
  }

  @HostListener("window:scroll", []) onScroll(): void {
    setTimeout(() => {
      this.handleSticky("scroll");
    });
  }

  preventPrefixEdit(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const cursorPos = input.selectionStart || 0;
    const prefixLength = 4;

    const blockedKeys = ['Backspace', 'Delete', 'ArrowLeft'];

    // Block editing inside prefix
    if (cursorPos <= prefixLength && blockedKeys.includes(event.key)) {    
      event.preventDefault();
    }

    // Block typing inside prefix
    if (cursorPos < prefixLength && event.key.length === 1) {
      event.preventDefault();
    }
  }

  enforcePrefix(): void {
    const prefix = '+974';

    if (!this.mobileNumber || this.mobileNumber.length < prefix.length) {
      this.mobileNumber = prefix;
      return;
    }

    // Remove anything that is not a digit after prefix
    let value = this.mobileNumber;

    // console.log(value);
    
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');

    // console.log(digits);
    
    // Always slice AFTER country code (974)
    const national = digits.startsWith('974')
      ? digits.slice(3)
      : digits;

      // console.log(prefix + national);
      
    this.mobileNumber = prefix + national;
  }
  

  getFullName() {
    const firstName = this.userData?.firstName || "";
    const lastName = this.userData?.lastName || "";
    return firstName && lastName
      ? firstName + " " + lastName
      : firstName
      ? firstName
      : lastName
      ? lastName
      : "---";
  }

  getUserImage() {
    const defaultImage = "assets/images/userDefault.jpg";
    const img = this.userData?.imageID || "";
    return img
      ? this.sharedService.isValidImage(img)
        ? img
        : defaultImage
      : defaultImage;
  }
}
